import React from "react"
import TestimonialWrap from "../_testimonial/testimonialWrap"

const HomeTestimonial = () => {
  return (
    <>
      <div className="row text-center">
        <div className="col-lg-10 col-xl-10 col-xxl-8 mx-auto mb-6">
          <h2 className="fs-17 text-uppercase text-muted mb-3">
            Testimonials from our clients
          </h2>
        </div>
      </div>
      <TestimonialWrap />
    </>
  )
}

export default HomeTestimonial
